import React from 'react'
import styled from 'styled-components/macro'
import { BadgeErrorSVG } from '../Basic'
import { ReactComponent as CustomLogo } from '../Dependencies/unknown/custom_receptor.svg'
import palette from '../../../designSystem/variables/palette'
import { FRAMEWORK_MODEL_IDS } from '../../../Utils/globalEnums'
import { ReactComponent as SOC2Logo } from './soc2-logo.svg'
import { ReactComponent as ISOLogo } from './iso27001-logo.svg'
import { ReactComponent as HIPAALogo } from './hipaa-logo.svg'
import { ReactComponent as PCIDSSLogo } from './pcidss-logo.svg'
import { ReactComponent as GDPRLogo } from './gdpr-logo.svg'
import { ReactComponent as CCPALogo } from './ccpa-logo.svg'
import { ReactComponent as NISTCSFLogo } from './nist-csf-logo.svg'
import { ReactComponent as ISO27701PIMSLogo } from './iso27701-pims-logo.svg'
import { ReactComponent as NIST800171Logo } from './nist-800-171-logo.svg'
import { ReactComponent as DODCMMCLogo } from './dod-cmmc-logo.svg'
import { ReactComponent as HITRUSTLogo } from './hitrust-logo.svg'
import { ReactComponent as PCIDSSSAQDLogo } from './pcidsssaqd-logo.svg'
import { ReactComponent as PIPEDALogo } from './pipeda-logo.svg'
import { ReactComponent as TISAXLogo } from './tisax-logo.svg'
import { ReactComponent as SWIFTLogo } from './swift-logo.svg'
import { ReactComponent as LADMFLogo } from './ladmf-logo.svg'
import { ReactComponent as CMMCLevel1Logo } from './cmmc-level-1-logo.svg'
import { ReactComponent as CMMCLevel2Logo } from './cmmc-level-2-logo.svg'
import { ReactComponent as ISO27018Logo } from './iso27018-2025-logo.svg'

export { ReactComponent as SOC2Logo } from './soc2-logo.svg'
export { ReactComponent as ISOLogo } from './iso27001-logo.svg'
export { ReactComponent as HIPAALogo } from './hipaa-logo.svg'
export { ReactComponent as PCIDSSLogo } from './pcidss-logo.svg'
export { ReactComponent as GDPRLogo } from './gdpr-logo.svg'
export { ReactComponent as CCPALogo } from './ccpa-logo.svg'
export { ReactComponent as NISTCSFLogo } from './nist-csf-logo.svg'
export { ReactComponent as ISO27701PIMSLogo } from './iso27701-pims-logo.svg'
export { ReactComponent as NIST800171Logo } from './nist-800-171-logo.svg'
export { ReactComponent as DODCMMCLogo } from './dod-cmmc-logo.svg'
export { ReactComponent as HITRUSTLogo } from './hitrust-logo.svg'
export { ReactComponent as CustomLogo } from '../Dependencies/unknown/custom_receptor.svg'
export { ReactComponent as PCIDSSSAQDLogo } from './pcidsssaqd-logo.svg'
export { ReactComponent as PIPEDALogo } from './pipeda-logo.svg'
export { ReactComponent as TISAXLogo } from './tisax-logo.svg'
export { ReactComponent as SWIFTLogo } from './swift-logo.svg'
export { ReactComponent as LADMFLogo } from './ladmf-logo.svg'
export { ReactComponent as CMMCLevel1Logo } from './cmmc-level-1-logo.svg'
export { ReactComponent as CMMCLevel2Logo } from './cmmc-level-2-logo.svg'
export { ReactComponent as ISO27018Logo } from './iso27018-2025-logo.svg'

const DEFAULT_STYLES = {
  width: '100%',
  height: '100%',
  maxWidth: '174px',
  maxHeight: '174px',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
}

const CustomFrameworkLogoContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 16px;
  background-color: ${palette.neutral[30]};
  border-radius: 16px;
  height: 104px;
  width: 104px;
  margin: 35px;
`

const CustomFrameworkLogo = () => {
  return (
    <CustomFrameworkLogoContainer>
      <CustomLogo />
    </CustomFrameworkLogoContainer>
  )
}

export enum ComplianceLogos {
  SOC2 = 'SOC2',
  ISO27001 = 'ISO27001',
  HIPAA = 'HIPAA',
  PCIDSS = 'PCIDSS',
  GDPR = 'GDPR',
  CCPALogo = 'CCPALogo',
  NISTCSFLogo = 'NISTCSFLogo',
  ISO27701PIMS = 'ISO27701PIMS',
  NIST800171 = 'NIST800171',
  DODCMMC = 'DODCMMC',
  HITRUST = 'HITRUST',
  PCIDSSSAQD = 'PCIDSSSAQD',
  PIPEDA = 'PIPEDA',
  CUSTOM = 'CUSTOM',
  UNKNOWN = 'UNKNOWN',
  SWIFT = 'SWIFT',
  TISAX = 'TISAX',
  LADMF = 'LADMF',
  CMMC_LEVEL_1 = 'CMMC_LEVEL_1',
  CMMC_LEVEL_2 = 'CMMC_LEVEL_2',
  ISO27018 = 'ISO27018',
}

export const FrameworkModelIdToComplianceLogo = {
  [FRAMEWORK_MODEL_IDS.SOC2]: ComplianceLogos.SOC2,
  [FRAMEWORK_MODEL_IDS.ISO27001]: ComplianceLogos.ISO27001,
  [FRAMEWORK_MODEL_IDS.HIPAA]: ComplianceLogos.HIPAA,
  [FRAMEWORK_MODEL_IDS.PCISAQD]: ComplianceLogos.PCIDSSSAQD,
  [FRAMEWORK_MODEL_IDS.PCISAQA]: ComplianceLogos.PCIDSSSAQD,
  [FRAMEWORK_MODEL_IDS.PCIDSS]: ComplianceLogos.PCIDSS,
  [FRAMEWORK_MODEL_IDS.GDPR_DC]: ComplianceLogos.GDPR,
  [FRAMEWORK_MODEL_IDS.GDPR_DP]: ComplianceLogos.GDPR,
  [FRAMEWORK_MODEL_IDS.CCPA]: ComplianceLogos.CCPALogo,
  [FRAMEWORK_MODEL_IDS.NISTCSF]: ComplianceLogos.NISTCSFLogo,
  [FRAMEWORK_MODEL_IDS.ISO27701]: ComplianceLogos.ISO27701PIMS,
  [FRAMEWORK_MODEL_IDS.ISO27701_DC]: ComplianceLogos.ISO27701PIMS,
  [FRAMEWORK_MODEL_IDS.ISO27701_DP]: ComplianceLogos.ISO27701PIMS,
  [FRAMEWORK_MODEL_IDS.NIST800171]: ComplianceLogos.NIST800171,
  [FRAMEWORK_MODEL_IDS.DODCMMC]: ComplianceLogos.DODCMMC,
  [FRAMEWORK_MODEL_IDS.HITRUST]: ComplianceLogos.HITRUST,
  [FRAMEWORK_MODEL_IDS.PIPEDA_DC]: ComplianceLogos.PIPEDA,
  [FRAMEWORK_MODEL_IDS.PIPEDA_DP]: ComplianceLogos.PIPEDA,
  [FRAMEWORK_MODEL_IDS.CUSTOM]: ComplianceLogos.CUSTOM,
  [FRAMEWORK_MODEL_IDS.GDPR]: ComplianceLogos.GDPR,
  [FRAMEWORK_MODEL_IDS.NYDFS]: ComplianceLogos.UNKNOWN,
  [FRAMEWORK_MODEL_IDS.SWIFT_CSCF_A1]: ComplianceLogos.SWIFT,
  [FRAMEWORK_MODEL_IDS.SWIFT_CSCF_A2]: ComplianceLogos.SWIFT,
  [FRAMEWORK_MODEL_IDS.SWIFT_CSCF_A3]: ComplianceLogos.SWIFT,
  [FRAMEWORK_MODEL_IDS.SWIFT_CSCF_A4]: ComplianceLogos.SWIFT,
  [FRAMEWORK_MODEL_IDS.SWIFT_CSCF_B]: ComplianceLogos.SWIFT,
  [FRAMEWORK_MODEL_IDS.SWIFT_PSCF]: ComplianceLogos.SWIFT,
  [FRAMEWORK_MODEL_IDS.TISAX_VDA_ISA]: ComplianceLogos.TISAX,
  [FRAMEWORK_MODEL_IDS.LADMF]: ComplianceLogos.LADMF,
  [FRAMEWORK_MODEL_IDS.SOC1]: ComplianceLogos.UNKNOWN,
  [FRAMEWORK_MODEL_IDS.TEST]: ComplianceLogos.UNKNOWN,
  [FRAMEWORK_MODEL_IDS.CMMC_LEVEL_1]: ComplianceLogos.CMMC_LEVEL_1,
  [FRAMEWORK_MODEL_IDS.CMMC_LEVEL_2]: ComplianceLogos.CMMC_LEVEL_2,
  [FRAMEWORK_MODEL_IDS.ISO27018]: ComplianceLogos.ISO27018,
}

export const ComplianceLogoComponent = ({
  complianceLogo,
  styles = DEFAULT_STYLES,
}: {
  complianceLogo?: ComplianceLogos
  styles?: React.CSSProperties
}): JSX.Element => {
  switch (complianceLogo) {
    case ComplianceLogos.SOC2:
      return <SOC2Logo style={styles} />
    case ComplianceLogos.ISO27001:
      return <ISOLogo style={styles} />
    case ComplianceLogos.HIPAA:
      return <HIPAALogo style={styles} />
    case ComplianceLogos.PCIDSSSAQD:
      return <PCIDSSSAQDLogo style={styles} />
    case ComplianceLogos.PCIDSS:
      return <PCIDSSLogo style={styles} />
    case ComplianceLogos.GDPR:
      return <GDPRLogo style={styles} />
    case ComplianceLogos.CCPALogo:
      return <CCPALogo style={styles} />
    case ComplianceLogos.NISTCSFLogo:
      return <NISTCSFLogo style={styles} />
    case ComplianceLogos.ISO27701PIMS:
      return <ISO27701PIMSLogo style={styles} />
    case ComplianceLogos.NIST800171:
      return <NIST800171Logo style={styles} />
    case ComplianceLogos.DODCMMC:
      return <DODCMMCLogo style={styles} />
    case ComplianceLogos.HITRUST:
      return <HITRUSTLogo style={styles} />
    case ComplianceLogos.PIPEDA:
      return <PIPEDALogo style={styles} />
    case ComplianceLogos.CUSTOM:
      return <CustomFrameworkLogo />
    case ComplianceLogos.SWIFT:
      return <SWIFTLogo style={styles} />
    case ComplianceLogos.TISAX:
      return <TISAXLogo style={styles} />
    case ComplianceLogos.LADMF:
      return <LADMFLogo style={styles} />
    case ComplianceLogos.CMMC_LEVEL_1:
      return <CMMCLevel1Logo style={styles} />
    case ComplianceLogos.CMMC_LEVEL_2:
      return <CMMCLevel2Logo style={styles} />
    case ComplianceLogos.ISO27018:
      return <ISO27018Logo style={styles} />
    default:
      return <BadgeErrorSVG style={styles} />
  }
}
